
import { collectMixin } from '@/mixins'

import foFooter from '@/components/footer/footer.vue'
import foHeader from '@/components/header/header.vue'
import DrivePickupDsk from '@/views/Drive/Pickup/pickup-dsk.vue'
import DrivePickupPhone from '@/views/Drive/Pickup/pickup-phone.vue'
import DrivePickupValidation from '@/views/Drive/Validation/validation.vue'

import { ClientPageType } from '@/constants'
import { dateHelper } from '@/helpers/dateHelper'
import { SnackBarType } from '@/store/types'
import { COLLECT_STATUSES } from '@meltingpoint/shared-statuses'
import mixins from 'vue-typed-mixins'

export default mixins(collectMixin).extend({
  name: 'drive-pickup',
  components: {
    foHeader,
    foFooter,
    DrivePickupDsk,
    DrivePickupPhone,
    DrivePickupValidation,
  },
  data() {
    return {
      showSuccess: false,
      ClientPageType,
      hasLoaded: false,
    }
  },
  async mounted() {
    try {
      dateHelper.setTimeZone('UTC')

      const {
        query: { language }
      } = this.$route

      this.language = language?.toString() || null

      await this.getCollect(
        this.showSuccess
          ? ClientPageType.COLLECT.DRIVE_SLOT_SUCCESS
          : ClientPageType.COLLECT.DRIVE_SLOT,
        this.language || '',
      )

      if (this.collect!.collectStatus.find(status => status.status === COLLECT_STATUSES.PICK_UP_OK)) {
        this.$router.push({ name: ClientPageType.COLLECT.REPORT_PRESENCE_AT_DRIVE_SUCCESS })
      }
    } catch (e) {
      this.$store.dispatch('setSnackbar', {
        message: this.$t('messages.error'),
        type: SnackBarType.ERROR,
      })
    }

    this.hasLoaded = true
  },
  watch: {
    showSuccess() {
      this.language = null

      this.getCollect(
        this.showSuccess
          ? ClientPageType.COLLECT.DRIVE_SLOT_SUCCESS
          : ClientPageType.COLLECT.DRIVE_SLOT,
      )
    },
  },
})
